export default __webpack_public_path__ + "static/media/questboard.257eb9b5.png";